import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import {InfoDropdown} from '../InfoDropdown/InfoDropdown';

import {orangeColors, neutral} from '../../../layouts/theme/designSystem';

const FAQ_ITEM_IDS = ['first', 'second', 'third', 'fourth', 'fifth'] as const;

export const FaqSection = () => {
  const {t} = useTranslation();

  return (
    <Grid
      id='faq'
      width='100%'
      sx={{
        py: {xs: 6, md: 8},
        px: {xs: 2, sm: 3},
        background: 'linear-gradient(180deg, #ffdeb3 0%, #f5f5f5 68.75%, #f5f5f5 100%)',
        scrollMarginTop: {xs: '96px', md: '140px'},
      }}
    >
      <Box sx={{maxWidth: '1120px', mx: 'auto'}}>
        <Typography
          sx={{
            color: orangeColors[900],
            fontWeight: 500,
            fontSize: {xs: '1.125rem', md: '1.25rem'},
            lineHeight: 1.5,
            textAlign: 'center',
          }}
        >
          {t('b2b.faqSection.eyebrow')}
        </Typography>

        <Typography
          sx={{
            mt: 1,
            color: neutral['primary-black'],
            fontWeight: 700,
            fontSize: {xs: '2rem', sm: '2.25rem', md: '3rem'},
            lineHeight: 1.2,
            textAlign: 'center',
          }}
        >
          {t('b2b.faqSection.headline')}
        </Typography>

        <Box sx={{mt: {xs: 4, md: 5}, maxWidth: '560px', mx: 'auto'}}>
          {FAQ_ITEM_IDS.map(itemId => (
            <InfoDropdown
              key={itemId}
              title={t(`b2b.faqSection.items.${itemId}.title`)}
              text={t(`b2b.faqSection.items.${itemId}.text`)}
            />
          ))}
        </Box>
      </Box>
    </Grid>
  );
};
